import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { useWorkspace } from '../../context/WorkspaceContext';

export default function WorkspaceLoginDialog() {
  const {
    loginOpen,
    closeLogin,
    login,
    loginError,
    loginLoading,
    workspace,
  } = useWorkspace();
  const [username, setUsername] = useState(workspace?.displayName || '');

  useEffect(() => {
    if (loginOpen) {
      setUsername(workspace?.displayName || '');
    }
  }, [loginOpen, workspace?.displayName]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await login(username.trim());
  };

  return (
    <Dialog open={loginOpen} onClose={closeLogin} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Sign in</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Enter a username to access your saved and recent calculations on any
            device. No password — anyone who knows the same username shares that
            workspace.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            disabled={loginLoading}
            inputProps={{ maxLength: 100 }}
          />
          {loginError ? (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {loginError}
            </Typography>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeLogin} disabled={loginLoading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={loginLoading || username.trim().length < 2}
          >
            {loginLoading ? 'Signing in…' : 'Sign in'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
